import { createSelector } from 'reselect';
import { selectUserProfile } from '../UserProfile/selectors';

export const getUserBadges = createSelector(
  selectUserProfile,
  userProfile => {
    return userProfile.badges;
  },
);



// WEBPACK FOOTER //
// ./src/containers/Badges/selectors.ts